/**
 * A list re-read during a visit, with *New* kept on whatever was new when the visit began —
 * TROOP-268.
 *
 * The noticeboard re-reads itself every few minutes so its documents' signed links do not lapse
 * (TROOP-255). By then this page has marked its cards seen, so the server answers `isNew: false`
 * for them, and taking that answer whole would wipe the marker off a card the reader may not have
 * reached yet. The rule is that the marker stays for the visit that drew it, as a thread's unread
 * divider does — so a row that was new on this screen stays new on it, and a row the re-read calls
 * new is new whether or not it was before.
 */
export function keepNewForTheVisit<T extends { id: string; isNew: boolean }>(
  previous: readonly T[] | null,
  next: readonly T[],
): T[] {
  const wasNew = new Set((previous ?? []).filter((row) => row.isNew).map((row) => row.id));

  return next.map((row) => (row.isNew || !wasNew.has(row.id) ? row : { ...row, isNew: true }));
}
